import {createSlice} from '@reduxjs/toolkit'

// ** Config
import themeConfig from '@configs/themeConfig'

const initialMenuCollapsed = () => {
    const item = window.localStorage.getItem('menuCollapsed')
    return item ? JSON.parse(item) : themeConfig.layout.menu.isCollapsed
}

const initialDirection = () => {
    const item = window.localStorage.getItem('direction')
    return item ? JSON.parse(item) === 'rtl' : themeConfig.layout.isRTL
}

const initialSkin = () => {
    const item = window.localStorage.getItem('skin')
    return item ? JSON.parse(item) : themeConfig.layout.skin
}

const initialLanguage = () => {
    if (!window.localStorage.getItem('i18nextLng')) {
        window.localStorage.setItem('i18nextLng', 'tr')
    }
    return window.localStorage.getItem('i18nextLng')
}

const handleSetInitiaLanguage = (lang) => {
    window.localStorage.setItem('i18nextLng', lang)
}

export const layoutSlice = createSlice({
    name: 'layout',
    initialState: {
        language: initialLanguage(),
        skin: initialSkin(),
        isRTL: initialDirection(),
        layout: themeConfig.layout.type,
        lastLayout: themeConfig.layout.type,
        menuCollapsed: initialMenuCollapsed(),
        footerType: themeConfig.layout.footer.type,
        navbarType: themeConfig.layout.navbar.type,
        menuHidden: themeConfig.layout.menu.isHidden,
        contentWidth: themeConfig.layout.contentWidth,
        routerTransition: themeConfig.layout.routerTransition,
        navbarColor: themeConfig.layout.navbar.backgroundColor
    },
    reducers: {
        handleRTL: (state, action) => {
            state.isRTL = action.payload === 'rtl'
            window.localStorage.setItem('direction', JSON.stringify(action.payload))
        },
        handleSkin: (state, action) => {
            state.skin = action.payload
            window.localStorage.setItem('skin', JSON.stringify(action.payload))
        },
        handleLayout: (state, action) => {
            state.layout = action.payload
        },
        handleFooterType: (state, action) => {
            state.footerType = action.payload
        },
        handleNavbarType: (state, action) => {
            state.navbarType = action.payload
        },
        handleMenuHidden: (state, action) => {
            state.menuHidden = action.payload
        },
        handleLastLayout: (state, action) => {
            state.lastLayout = action.payload
        },
        handleNavbarColor: (state, action) => {
            state.navbarColor = action.payload
        },
        handleContentWidth: (state, action) => {
            state.contentWidth = action.payload
        },
        handleMenuCollapsed: (state, action) => {
            state.menuCollapsed = action.payload
            window.localStorage.setItem('menuCollapsed', JSON.stringify(action.payload))
        },
        handleRouterTransition: (state, action) => {
            state.routerTransition = action.payload
        }
    }
})

export const {
    handleRTL,
    handleSkin,
    handleLayout,
    handleLastLayout,
    handleMenuHidden,
    handleNavbarType,
    handleFooterType,
    handleNavbarColor,
    handleContentWidth,
    handleMenuCollapsed,
    handleRouterTransition
} = layoutSlice.actions

export default layoutSlice.reducer

export {
    initialLanguage,
    handleSetInitiaLanguage
}
